"use client";

import { useMemo } from "react";
import styles from "../css/obstetrics-overview.module.css";

export default function ObstetricsOverview({ patientData = {} }) {
  const obs = useMemo(() => {
    return patientData?.obstetricsOverview || patientData?.obstetrics || {};
  }, [patientData]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.icon}>🕒</span>
        <h3 className={styles.title}>Obstetric History</h3>
      </div>

      <div className={styles.grid}>
        <div className={styles.field}>
          <label>Gravida</label>
          <div className={styles.value}>{obs.gravida || ""}</div>
        </div>
        <div className={styles.field}>
          <label>Para</label>
          <div className={styles.value}>{obs.para || ""}</div>
        </div>
        <div className={styles.field}>
          <label>LMP</label>
          <div className={styles.value}>{obs.lmp || ""}</div>
        </div>
        <div className={styles.field}>
          <label>EDD</label>
          <div className={styles.value}>{obs.edd || ""}</div>
        </div>
        <div className={styles.fieldFull}>
          <label>Notes</label>
          <div className={styles.value}>{obs.notes || ""}</div>
        </div>
      </div>
    </div>
  );
}